import api from "../../index.js";

export const GetCommissionApi = (params) => api.get(`IBMaster/MyEarning-IBCommissionReports?${params}`);
export const GetCommissionAssignTreeApi = (userId, params) => api.get(`IBMaster/IBCommission-AssignTree/${userId}?${params}`);
export const GetCommissionlotApi = (params) => api.get(`IBMaster/Get-Total-Commission-Lots?${params}`);